const INPUT_BASE =
  "w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-800 shadow-sm focus:border-[#007BFF] focus:outline-none focus:ring-1 focus:ring-[#007BFF]";

export const MODAL_LABEL = "mb-1 block text-xs font-semibold text-gray-600";
export const MODAL_INPUT = INPUT_BASE;
export const MODAL_SELECT = `${INPUT_BASE} cursor-pointer`;
export const MODAL_READONLY =
  "w-full min-h-[42px] rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-800";
export const MODAL_NOTES =
  "min-h-[120px] resize-y overflow-y-auto leading-relaxed box-border";
export const MODAL_FIELD = "min-w-0";
export const MODAL_ROW_2 = "grid grid-cols-2 gap-4";
export const MODAL_NOTES_VIEW =
  "max-h-[120px] min-h-[42px] overflow-y-auto whitespace-pre-wrap leading-relaxed";

export function ModalFooterButton({
  children,
  onClick,
  type = "button",
  primary = false,
  disabled = false,
  form,
}) {
  const base =
    "inline-flex items-center justify-center rounded-lg px-5 py-2 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50";

  return (
    <button
      type={type}
      form={form}
      onClick={onClick}
      disabled={disabled}
      className={
        primary
          ? `${base} bg-[#007BFF] text-white shadow-sm hover:bg-[#0069D9]`
          : `${base} border border-gray-300 bg-white text-gray-700 hover:bg-gray-50`
      }
    >
      {children}
    </button>
  );
}

export function ProgressInline({ value, onChange, readOnly = false }) {
  const progress = Math.min(100, Math.max(0, Number(value) || 0));

  return (
    <div
      className={`flex items-center gap-3 rounded-lg border px-3 py-2.5 ${
        readOnly
          ? "border-gray-200 bg-gray-50"
          : "border-gray-300 bg-white shadow-sm"
      }`}
    >
      <div className="relative flex h-6 flex-1 items-center">
        <div
          className="pointer-events-none absolute inset-x-0 h-2 overflow-hidden rounded-full bg-gray-200"
          aria-hidden="true"
        >
          <div
            className="h-full rounded-full bg-[#007BFF] transition-all duration-150"
            style={{ width: `${progress}%` }}
          />
        </div>
        {readOnly ? null : (
          <input
            type="range"
            min={0}
            max={100}
            step={1}
            value={progress}
            onChange={(e) => onChange?.(Number(e.target.value))}
            className="dal-progress-slider relative z-10 w-full cursor-pointer appearance-none bg-transparent"
            style={{ height: "24px" }}
            aria-label="Task progress"
          />
        )}
      </div>
      <span className="min-w-[40px] text-right text-sm font-bold text-[#007BFF]">
        {progress}%
      </span>
    </div>
  );
}
